import { _ as _extends } from './extends-a2cb9f0c.esm.js';
import React__default from 'react';
import { A as AppList } from './index-74f0c7d2.esm.js';
import { A as AppSwitch } from './index-dbc9bff8.esm.js';

const AppMultiSwitchOptions = _ref => {
  let {
    handleTick = () => {},
    listData,
    onChange = () => {},
    labelTextStyle,
    labelStyle,
    ...props
  } = _ref;
  return /*#__PURE__*/React__default.createElement(AppList, _extends({}, props, {
    keyExtractor: "id",
    items: listData,
    renderItem: _ref2 => {
      let {
        item
      } = _ref2;
      return /*#__PURE__*/React__default.createElement(AppSwitch, {
        labelTextStyle: labelTextStyle,
        labelStyle: labelStyle,
        wrapperStyle: {
          paddingVertical: 10
        },
        showTextInputLabel: true,
        label: item.title,
        isTicked: item.ticked,
        onChange: () => {
          handleTick(item, "ticked");
          onChange(item);
        }
      });
    }
  }));
};
AppMultiSwitchOptions.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "AppMultiSwitchOptions",
  "props": {
    "handleTick": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "required": false
    },
    "onChange": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "required": false
    }
  }
};

export { AppMultiSwitchOptions as A };
